import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import langMsg from '@blade-sxp/search-center/lang/index';
import Paint from '@blade/common/components/paint/src/index.vue';
import { fromPage, queryType } from '@blade-sxp/search-center/interfaces/enum';
import colors from '@/styles/color.scss';
import ImageUtil from '@blade/common/utils/screenShot';
let AlarmCenter = class AlarmCenter extends Vue {
    dialogVisible;
    collapseList;
    base64Image;
    loading;
    textBtn;
    isShow = false;
    scale = 1;
    maxScale = 4;
    minScale = 0.5;
    activeNames = '';
    atlas = [];
    drawStatus = false;
    imgStyle = {
        width: '0px',
        height: '0px',
    };
    drawOptions = {
        hover: {
            fillStyle: 'rgba(0, 0, 0, 0)',
            lineWidth: 2,
            strokeStyle: colors.searchYellow,
        },
        normal: {
            fillStyle: 'rgba(0, 0, 0, 0)',
            lineWidth: 2,
            strokeStyle: colors.searchYellow,
        },
    };
    ratio = undefined;
    changeImg(index, val) {
        this.$set(val, 'checkIndex', val.checkIndex !== index ? index : '');
    }
    handleDrawRoi() {
        this.drawStatus = true;
    }
    get IsChoose() {
        return this.collapseList?.filter((item) => item.checkIndex || item.checkIndex === 0).length;
    }
    getFeatureLength(val) {
        if (val.featureList) {
            return val.featureList.length;
        }
        return 0;
    }
    getFeatureText(index) {
        if (this.activeNames === index) {
            return this.$t('hideAll');
        }
        return this.$t('showAll');
    }
    handleClose() {
        this.$emit('close');
    }
    search() {
        // const firstCollapse = this.collapseList?.find((item: any) => typeof item.checkIndex === 'number' && item?.featureList?.length);
        // const selectData = firstCollapse ? [firstCollapse?.['featureList']?.[firstCollapse.checkIndex as number]] : [];
        // this.$emit('retrieval', fromPage.FEATURES_PAGE, selectData);
        const selectData = [];
        this.collapseList?.forEach((item) => {
            if (item?.featureList?.length > 0 && typeof item.checkIndex === 'number') {
                selectData.push(item.featureList[item.checkIndex]);
            }
        });
        console.log('selectData', selectData, this.collapseList);
        this.$emit('retrieval', fromPage.FEATURES_PAGE, selectData);
    }
    get conputeStyle() {
        const scale = this.scale;
        return {
            transform: `scale(${scale})`,
        };
    }
    changeCollapse(item, index) {
        this.drawFace(item.featureList);
        this.getFeatureText(index);
        this.updateDrawState(item, index);
    }
    updateDrawState(item, index) {
        // 更新可绘制状态
        if (!(item.canDraw && this.activeNames === index)) {
            this.drawStatus = false;
        }
    }
    imageUrl(val) {
        if (val) {
            this.activeNames = '';
            this.collapseList?.forEach((item) => {
                if (item.featureList) {
                    this.drawFace(item.featureList);
                }
            });
            this.$nextTick(() => {
                this.updateImgStyle();
            });
        }
        else {
            this.atlas = [];
        }
    }
    updateImgStyle() {
        const { width, height } = this.getImgStyle();
        this.imgStyle = { width: `${width}px`, height: `${height}px` };
    }
    async drawend(data) {
        const vertices = data?.[0]?.vertices || [];
        if (vertices.length !== 2)
            return;
        const { width, height } = this.getImgStyle();
        const imgUrl = (await ImageUtil.screenShot(vertices, this.base64Image, {
            width,
            height,
        }));
        this.addFeatureListImg('ALGO', imgUrl);
        this.atlas = [];
        this.drawStatus = false;
    }
    addFeatureListImg(type, url) {
        const featureItem = { imageUrl: url, featureType: queryType[type] };
        const collapse = this.collapseList?.find((item) => item.featureType === queryType[type]);
        if (!collapse)
            return;
        if (collapse.maxLength && collapse?.featureList?.length >= collapse.maxLength)
            return;
        collapse.featureList = [...collapse?.featureList, featureItem];
    }
    drawFace(vertices) {
        // 重复获取
        this.$nextTick(() => {
            const imgElement = this.$refs.imgElement;
            let { offsetWidth: outWidth, offsetHeight: outHeight } = imgElement;
            const outRatio = outWidth / outHeight;
            const canvas = this.$refs.mycanvas;
            if (!canvas) {
                return false;
            }
            // 可以理解为一个画笔，可画路径、矩形、文字、图像
            const context = canvas.getContext('2d');
            const img = new Image();
            img.src = this.base64Image;
            img.crossOrigin = '';
            // 加载图片
            img.onload = () => {
                if (img.complete) {
                    // 根据图像重新设定了canvas的长宽
                    let { height, width } = img;
                    !this.ratio && (this.ratio = width / height);
                    this.updateImgStyle();
                    let scale = 1;
                    if (this.ratio > outRatio) {
                        // 以宽为准
                        width = outWidth;
                        height = outWidth / this.ratio;
                    }
                    else {
                        // 以高为准
                        height = outHeight;
                        width = height * this.ratio;
                    }
                    canvas?.setAttribute('width', String(width));
                    canvas?.setAttribute('height', String(height));
                    // 绘制图片
                    context?.drawImage(img, 0, 0, width, height); // 画布大小
                    context.strokeStyle = colors.white; // 矩形线颜色
                    // context.lineWidth = 1; // 矩形线宽
                    vertices?.forEach((item, index) => {
                        if (item?.boundingPoly?.vertices) {
                            const cv = this.$refs.matting;
                            const cv1 = cv?.getContext('2d');
                            let imageData = {};
                            const verticesData = item.boundingPoly.vertices;
                            const x = verticesData[0].x;
                            const y = verticesData[0].y;
                            const rightX = verticesData[1].x - x;
                            const rightY = verticesData[1].y - y;
                            const startX = x * width;
                            const startY = y * height;
                            const endX = Math.abs(rightX * width);
                            const endY = Math.abs(rightY * height);
                            context?.strokeRect(startX, startY, endX, endY); // 绘制矩形 X y 长 宽
                            imageData = context?.getImageData(startX, startY, endX, endY);
                            cv1?.putImageData(imageData, 0, 0);
                            const base64Img = this.getCanvasImageData(imageData, endX, endY);
                            this.$emit('imageUrl', base64Img, index, vertices);
                        }
                    });
                }
            };
        });
    }
    getCanvasImageData(imgData, w, h) {
        const cv = document.createElement('canvas');
        const cv1 = cv?.getContext('2d');
        cv.width = w;
        cv.height = h;
        cv1?.putImageData(imgData, 0, 0, 0, 0, w, h);
        const base64Url = cv.toDataURL();
        cv.remove();
        return base64Url;
    }
    plus() {
        if (this.maxScale <= this.scale) {
            return (this.scale = this.maxScale);
        }
        this.scale += 0.1;
    }
    minus() {
        if (this.minScale >= this.scale) {
            return (this.scale = this.minScale);
        }
        this.scale -= 0.1;
    }
    getImgStyle() {
        const imgElement = this.$refs.imgElement;
        if (!imgElement)
            return { width: 0, height: 0 };
        let { offsetWidth: width, offsetHeight: height } = imgElement;
        if (this.ratio) {
            const eleRatio = width / height;
            if (this.ratio > eleRatio) {
                height = width / this.ratio;
            }
            else {
                width = height * this.ratio;
            }
        }
        return { width, height };
    }
    mounted() { }
    beforeDestroy() {
        this.atlas = [];
    }
};
__decorate([
    Prop({ default: false })
], AlarmCenter.prototype, "dialogVisible", void 0);
__decorate([
    Prop()
], AlarmCenter.prototype, "collapseList", void 0);
__decorate([
    Prop()
], AlarmCenter.prototype, "base64Image", void 0);
__decorate([
    Prop()
], AlarmCenter.prototype, "loading", void 0);
__decorate([
    Prop({ default: 'search' })
], AlarmCenter.prototype, "textBtn", void 0);
__decorate([
    Watch('dialogVisible')
], AlarmCenter.prototype, "imageUrl", null);
AlarmCenter = __decorate([
    Component({
        name: 'SearchTag',
        components: {
            Paint,
        },
        i18n: {
            sharedMessages: langMsg,
        },
    })
], AlarmCenter);
export default AlarmCenter;
